


















import { Component, Vue } from 'vue-property-decorator';
import GalaHonorOverview from '~/components/GalaHonor/GalaHonorOverview.vue';
import GalaHonorActionHistory from '~/components/GalaHonor/GalaHonorActionHistory.vue';

@Component({
  components: { GalaHonorOverview, GalaHonorActionHistory },
})
export default class GalaHonorContainer extends Vue {
  items = [
    {
      title: this.$t('pages.galaHonor.overview'),
      icon: 'poll',
    },
    {
      title: this.$t('pages.galaHonor.actions'),
      icon: 'history',
    },
  ];
  activeTab = null;
  game = 'SpiderTanks';
}
